/* One footer owner. Localization/subscription submissions remain Shopify-owned. */
(() => {
  'use strict';
  const key = Symbol.for('pf.sitewide-footer.20261020');
  if (window[key]) return;
  const roots = new WeakMap();
  const selector = '[data-pf-site-footer]';
  const trackLink = (anchor) => {
    try {
      const shopify = window.Shopify;
      if (window.pfInternal || shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true
          || typeof shopify?.analytics?.publish !== 'function') return;
      const url = new URL(anchor.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      const path = url.pathname.replace(/^\/en-us(?=\/|$)/, '');
      const [kind, handle] = path.split('/').filter(Boolean);
      let name = 'pf_navigation_link_click';
      let fields = { action: kind || 'home', section: handle || kind || 'home' };
      if (kind === 'collections' && handle) { name = 'pf_home_collection_select'; fields = { style: handle }; }
      if (kind === 'products' && handle) {
        name = handle === 'custom-poster' ? 'pf_photo_print_entry_click' : 'pf_home_product_select';
        fields = { product: handle };
      }
      const data = { ...fields, source: 'footer_navigation', market: window.PFMarket?.country };
      const safe = Object.fromEntries(Object.entries(data).filter(([, value]) => typeof value === 'string' && /^[a-zA-Z0-9_-]{1,120}$/.test(value)));
      Promise.resolve(shopify.analytics.publish(name, safe)).catch(() => {});
    } catch { /* Analytics never blocks a link. */ }
  };
  const mount = (root) => {
    if (roots.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const mobile = window.matchMedia('(max-width: 767px)');
    const rows = [...root.querySelectorAll('[data-pf-footer-toggle]')].map(button => ({
      button, panel: root.querySelector(`#${button.getAttribute('aria-controls')}`), open: false,
    })).filter(row => row.panel);
    const sync = () => rows.forEach(row => {
      const expanded = !mobile.matches || row.open;
      row.button.disabled = !mobile.matches;
      row.button.setAttribute('aria-expanded', String(expanded));
      row.panel.hidden = !expanded;
    });
    rows.forEach(row => row.button.addEventListener('click', () => {
      if (!mobile.matches) return;
      row.open = !row.open;
      sync();
    }, options));
    root.addEventListener('click', event => {
      const anchor = event.target.closest?.('a[href]');
      if (anchor && root.contains(anchor)) trackLink(anchor);
    }, options);
    mobile.addEventListener('change', sync, options);
    root.setAttribute('data-pf-footer-enhanced', 'true');
    sync();
    roots.set(root, () => {
      controller.abort();
      rows.forEach(row => { row.button.disabled = false; row.button.setAttribute('aria-expanded', 'true'); row.panel.hidden = false; });
      root.removeAttribute('data-pf-footer-enhanced');
      roots.delete(root);
    });
  };
  const find = (scope, action) => {
    if (scope.matches?.(selector)) action(scope);
    scope.querySelectorAll?.(selector).forEach(action);
  };
  window[key] = true;
  document.addEventListener('shopify:section:load', event => find(event.target, mount));
  document.addEventListener('shopify:section:unload', event => find(event.target, root => roots.get(root)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => find(document, mount), { once: true });
  else find(document, mount);
})();
